import { Typography } from '@mui/material'
import CenteredText from './CenteredText'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'

const DefaultBeforeSelectText = () => {
  const { t_ } = useSmartTranslation()
  return <CenteredText><Typography variant='h6'>{t_('Select the operation')}</Typography></CenteredText>
}

export default DefaultBeforeSelectText
